import {useMutation} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_UPDATE_UPGRADE_CHECKER_VERSION_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkUpgradeCheckerVersionForm} from "@/pages/checks/list/actions/bulkUpgradeCheckerVersion/BulkUpgradeCheckerVersionForm.tsx";

export interface EditCheckUpgradeCheckerVersionFormValues {
  msp_version: number[];
}

export interface BulkUpgradeCheckerVersionModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkUpgradeCheckerVersionModal = ({
  selectedItemsIds,
  show,
  setShow,
  onSuccess,
}: BulkUpgradeCheckerVersionModalProps) => {
  const [updateChecksUpgradeCheckerVersions, {data, loading}] = useMutation<GraphQLResponse<null>>(
    GQL_UPDATE_UPGRADE_CHECKER_VERSION_STATE
  );

  const handleSubmit = async (data: EditCheckUpgradeCheckerVersionFormValues) => {
    const response = await updateChecksUpgradeCheckerVersions({
      variables: {
        ids: selectedItemsIds,
        msp_version: Number(data.msp_version),
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkUpgradeCheckerVersionForm";
  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={"Upgrade checker version"}
    >
      <BulkUpgradeCheckerVersionForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
